<template>
    <div class="zl-card-title">
        <h3 class="zl-title-text">
            <div class="slot">
                <slot name="title">{{ title }}</slot>
            </div>
        </h3>
        <div>
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ZlCardTitle',
        props: {
            title: {
                type: String,
                default: '',
            },
        },
    }
</script>

<style lang="scss">
.zl-card-title{
    background: #FFFFFF;
    box-shadow: 2px 4px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    h3.zl-title-text{
        background: url("../assets/icon/cardTitle.svg") left 3px no-repeat;
        background-size: auto 1em ;
        font-size: 16px;
        font-weight: 700;
        color: #262626;
        line-height: 22px;
        padding-left: 10px;
        position: relative;
        min-height: 22px;
    }

}
</style>
